<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表号')">
              <a-input :placeholder="$t('输入表号进行查询')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表类型')">
              <j-dict-select-tag v-model="queryParam.meterType" :placeholder="$t('请表类型')" dictCode="meter_type" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('处理状态')">
              <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                <a-select-option value="0">
                  {{ $t('未处理') }}
                </a-select-option>
                <a-select-option value="1">
                  {{ $t('处理中') }}
                </a-select-option>
                <a-select-option value="2">
                  {{ $t('已处理') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('是否开户')">
              <a-select v-model="queryParam.mtState" style="width: 100%" :placeholder="$t('请选择是否开户')">
                <a-select-option :value="0">
                  {{ $t('未建档') }}
                </a-select-option>
                <a-select-option :value="1">
                  {{ $t('已建档') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('部门')">
              <a-select v-model="queryParam.sysOrgCode" :placeholder="$t('请选择部门')" style="margin-left:10px;width: 80%">
                <a-icon slot="suffixIcon" type="gold" />
                  <a-select-option
                    v-for="d in departList"
                    :key="d.id"
                    :value="d.orgCode">
                    {{ d.departName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <!--
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
              -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      -->
      <a-button type="primary" icon="download" @click="handleExportXls($t('失联告警'))">{{ $t('导出') }}</a-button>
      <!--
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <!--
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
      -->
      <a-button v-if="selectedRowKeys.length > 0" style="margin-left: 8px" type="primary" @click="batchDeal"> {{ $t('批量处理') }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onTableSelect,onSelectAll:onSelectAll,getCheckboxProps:getCheckboxProps}"
        >

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <span slot="meterDealStatus" slot-scope="text, record">
          <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
          <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
          <label v-else class="wait-status">{{ $t('未处理') }}</label>
        </span>
        <span slot="action" slot-scope="text, record" class="action">
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
            <a :disabled="record.meterDealStatus == 2" @click="handleDeal(record)">{{ $t('处理') }}</a>
          </span>

      </a-table>
    </div>
    <lose-connection-warn-detail-modal ref="modalForm" @ok="modalFormOk"></lose-connection-warn-detail-modal>
    <lose-connection-warn-deal-modal ref="dealModalForm" @ok="modalFormOk"></lose-connection-warn-deal-modal>
  </a-card>
</template>

<script>

  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import loseConnectionWarnDetailModal from './modules/loseConnectionWarnDetailModal'
  import loseConnectionWarnDealModal from './modules/loseConnectionWarnDealModal'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import {isUndefined} from '@/utils/validate'
  import { getAction } from '@/api/manage'

  export default {
    name: 'MeterMaintenanceWarnLastRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      loseConnectionWarnDetailModal,
      loseConnectionWarnDealModal
    },
   
    data () {
      return {
        description: 'meter_maintenance_warn_last_record管理页面',
        netTypeObj,
        meterTypeObj,
        url: {
          list: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/warnPageList",
          delete: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/exportXlsLostWarnList",
          importExcelUrl: "jeecg-charge/meter/meterMaintenanceWarnLastRecord/importExcel",
          
        },
        dictOptions:{},
        departList:[],
        uniqueParam: {meterWarnType: 3}
      }
    },
    created() {
      this.loadDepartList()
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true
          },
          {
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'meterType',
            customRender: (t,r,index) => {
              let data = meterTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('表安装地址'),
            align:"center",
            dataIndex: 'userMeterAddr',
            width: 150,
            ellipsis: true
          },
          {
            title: this.$t('告警描述'),
            align:"center",
            dataIndex: 'meterWarnDetail',
            width: 150,
            ellipsis: true
          },
          {
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('软件版本号'),
            align:"center",
            dataIndex: 'meterSoftVersion',
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('运营商'),
            align:"center",
            dataIndex: 'meterIotType',
            customRender: (t,r,index) => {
              let data = netTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('部门编号'),
            align:"center",
            dataIndex: 'sysOrgCode',
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('部门名称'),
            align:"center",
            dataIndex: 'departName',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('失联天数'),
            align:"center",
            dataIndex: 'lostContactDay',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('告警时间'),
            align:"center",
            dataIndex: 'updateTime',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    methods: {
      initDictConfig(){
      },
      handleDeal(record) {
        this.$refs.dealModalForm.edit(record);
        this.$refs.dealModalForm.title=this.$t("详情");
        this.$refs.dealModalForm.disableSubmit = false;
      },
      batchDeal() {
        // 批量处理告警
        if(this.selectionRows.length<1){
          this.$message.error(this.$t("请先选择需要批量处理的表号"))
          return
        }else{
          let meterIdList = []
          let meterDealStatus = ''
          for(let i = 0;i<this.selectionRows.length;i++) {
            if(i === 0) {
              meterDealStatus = this.selectionRows[0].meterDealStatus
            }else{
              if(meterDealStatus !== this.selectionRows[i].meterDealStatus) {
                this.$message.error(this.$t("选择批量处理的处理进度不一致不能操作，请重新选择同一处理进度的表具"))
                return
              }
            }
            meterIdList.push(this.selectionRows[i].meterId)
          }
          let record = {}
          record.meterIdList = meterIdList.join(',')
          record.meterDealStatus = meterDealStatus
          this.handleDeal(record)
        }
      },
      getCheckboxProps(record) {
        let props = {
          disabled: record.meterDealStatus == 2,
          meterDealStatus: record.meterDealStatus
        }
        return {props: {...props}};
      },
      loadDepartList(){
          let url = "/sys/user/getCurrentUserDeparts"
          getAction(url).then(res=>{
            if(res.success){
              let departs = res.result.list
              this.departList  = departs
            }
        })
      }
    }
  }
</script>
<style scoped>
</style>